import html2canvas from "html2canvas";

import AddGroupModalView from "./addGroupModal.html";
import PositionModalView from "../groups/PositionModal.html";
import PersonPositionAddressModalView from "./PersonPositionAddressModal.html";
import PersonPositionContactModalView from "./PersonPositionContactModal.html";
import AttendedEventsModalView from "./AttendedEventsModal.html";
import AllowedUsersModalView from "./AllowedUsersModal.html";
import TagsModalView from "../tags/TagsModal.html";
import AssignTagsPersonModalView from "../tags/AssignTagsModal.html";
import { log } from "fullcalendar/src/util";
import { logs } from "@opentelemetry/api-logs";

angular.module("persons")
    .controller("PersonsEditCtrl", ['foldersService', 'LoginService', 'notificationService', '$http', '$filter', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', 'treeService', '$sce', '$q', '$interval', '$timeout', 'uiGridConstants','clipboard', 'logService',
        function (foldersService, LoginService, notificationService, $http, $filter, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, treeService, $sce, $q, $interval, $timeout, uiGridConstants, clipboard, logService) {

            logService.debug("PersonsEditCtrl initialized from logService");

            $scope.urlApi = (window as any).CONFIG.api_url;

            $scope.changesNotSaved = false;
            //Comprobamos si la empresa tiene marcado la opción de el artículo 10 para mostrar las opciones en consecuencia
            $scope.tagsInFilter = [];
            $scope.article10 = false;
            $scope.article12 = false;
            $scope.default_order_article = "article12";
            $scope.is_duplicate = false;
            $scope.canManageEntityAcl = function (acl) {
                return LoginService.aclEnabled() && LoginService.permissionExist("ACL_MANAGE") && LoginService.userCanManageAcl(acl);
            };
            $scope.aclUsers = [];
            $scope.aclGroups = [];
            $scope.aclOptionsLoaded = false;
            $scope.aclDialogState = {
                visible: false,
                savedVersion: 0
            };

            let limit_image_height = 0;
            let limit_image_width = 0;

            $scope.loadCompany = function () {
                Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
                    $scope.app_enabled = results.public_guest_app_enabled;
                    if (results.article_10 == true) { $scope.article10 = true; }
                    if (results.article_12 == true) { $scope.article12 = true; }
                    $scope.default_order_article = results.default_order_article;
                    $scope.private_people_enabled = results.private_people_enabled;
                    $scope.private_people_enabled = results.private_people_enabled;
                    $scope.military_groups_enabled = results.military_groups_enabled;
                    const languageDefault = $scope.selectLanguages.filter(pt => { return pt.id == results.language_id });
                    $scope.selectedLanguage = languageDefault[0];
                });

            }

            setTimeout(function () {
                $scope.loadCompany();
            }, 200);


            let checkIfPositionIsVisible = function (personPosition) {

                if (personPosition.position_type == 'civil') {
                    return (personPosition.FK_persons_positions_positions.FK_positions_groups.is_historic || !$scope.person_groups.active)
                } else if  (personPosition.position_type == 'militar') {
                    return (personPosition.FK_persons_positions_positions.FK_positions_groups.is_historic || !$scope.person_groups_militar.active)
                }

                return false;

            }

            $scope.checkPositionVisibility = function () {
                $scope.person.FK_persons_positions_persons.forEach(function (position) {
                    position.show = checkIfPositionIsVisible(position);
                })
            }
            $scope.loadPersonsTreatments = function (reload) {
                Restangular.all('PersonsTreatments').getList().then(function (treatments) {
                    $scope.personTreatments = treatments;
                    const personDefault = $scope.personTreatments.filter(pt => { return pt.person_default });
                    $scope.selectedTreatment = personDefault[0];
                });

            };

            $scope.loadPersonsTreatments(false);

            let GetAllowedUsers = function () {
                Restangular.all("Persons").customGET("GetAllowedUsers", { id: $scope.person.id }).then(function (results) {
                    $scope.allowedUsers = results;
                })
            };
            let GetAllowedGroups = function () {
                Restangular.all("Persons").customGET("GetAllowedGroups", { id: $scope.person.id }).then(function (results) {
                    $scope.allowedGroups = results;
                })
            };

            let normalizeAclUser = function (user) {
                const name = user.name || user.username || ('User #' + user.id);
                const username = user.username || '';
                const words = name.trim().split(/\s+/);
                const initials = (words.length >= 2
                    ? words[0][0] + words[words.length - 1][0]
                    : name.slice(0, 2)
                ).toUpperCase();
                return {
                    id: user.id,
                    label: name,
                    initials: initials,
                    sub: (username && username !== name) ? username : (user.email || '')
                };
            };

            let normalizeAclGroup = function (group) {
                const name = group.name || ('Group #' + group.id);
                return {
                    id: group.id,
                    label: name,
                    initials: name.slice(0, 2).toUpperCase(),
                    sub: group.members_count ? (group.members_count + ' miembros') : ''
                };
            };

            $scope.loadAclOptions = function () {
                if ($scope.aclOptionsLoaded) {
                    return $q.when();
                }

                return $q.all([
                    Restangular.all('Users').getList(),
                    Restangular.all('UsersGroups').getList()
                ]).then(function (results) {
                    $scope.aclUsers = (results[0] || []).map(normalizeAclUser);
                    $scope.aclGroups = (results[1] || []).map(normalizeAclGroup);
                    $scope.aclOptionsLoaded = true;
                });
            };

            $scope.openAclDialog = function () {
                $scope.loadAclOptions().then(function () {
                    $scope.aclDialogState.visible = true;
                });
            };

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");
            $scope.allowDelete = LoginService.permissionExist("PERSONS_DELETE");
            $scope.allowDiscard = LoginService.permissionExist("PERSONS_DISCARD");
            $scope.allowFoldersFiles = LoginService.permissionExist("FILES_READ");

            //Usar estas variables, ya que se reutiliza el controlador en otro lado.
            $scope.stateParams_person_type = $stateParams.person_type;
            $scope.stateParams_id = $stateParams.id;
            $scope.personsIds = $stateParams.personsIds;
            $scope.personOptions = function (options) {
                // logService.debug(options);
                $scope.stateParams_person_type = options.person_type;
                $scope.callbackClose = options.callbackClose;
                $scope.stateParams_id = "";
                $scope.person.person_type = options.person_type;
            };

            var savedOptions = JSON.parse(localStorage.getItem("persons_options"));

            //preparamos barra de navegacion
            $scope.navigation = {
                _page: -1,
                _pageSize: 1,
                _pages: 1
            };

            let prepareTitle = function () {

                if ($stateParams.person_type == 'authority') {
                    $rootScope.title = $filter('translate')('persons.subtitle');
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('persons.title'), url: "persons.list({ person_type: '" + $stateParams.person_type + "', reset: false })" }
                    ];
                }

                /*
                    else if ($stateParams.person_type == 'other') {
                        $rootScope.title = $filter('translate')('persons.title_other');
                        $rootScope.breadcrumb = [
                            { title: $filter('translate')('persons.subtitle_other') }
                        ];
                    }
                    else if ($stateParams.person_type == 'inactive') {
                        $rootScope.title = $filter('translate')('persons.title_inactive');
                        $rootScope.breadcrumb = [
                            { title: $filter('translate')('persons.title_inactive') }
                        ];
                    }
                */

                else if ($stateParams.person_type == 'anonymous') {
                    $rootScope.title = $filter('translate')('persons.title_anonymous');
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('persons.title_anonymous') }
                    ];
                }
                else if ($stateParams.person_type == 'imported') {
                    $rootScope.title = $filter('translate')('persons.title_imported');
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('persons.title_imported') }
                    ];
                }
                else if ($stateParams.person_type == 'enrolled') {
                    $rootScope.title = $filter('translate')('inscriptions_forms.inscripted');
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('inscriptions_forms.inscripted') }
                    ];
                } else {
                    $rootScope.title = $filter('translate')('persons.title_all');
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('persons.title_all') }
                    ];
                }

                // Comprobamos si venimos desde duplicates_list y actualizamos el breadcrump en consecuencia

                if ($stateParams.coming_from_duplicates == true) {
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('persons.duplicates_title'), url: "persons.duplicates_list" }
                    ];
                }
            }

            $scope.prepareNavigationBar = function () {

                prepareTitle();
                $scope.changesNotSaved = false;
                var idxArrayPersonsResults = 0;

                if ($scope.navigation._page != -1) {

                    //if (savedOptions._pageSize < $scope.navigation._page) {
                    //    idxArrayPersonsResults = $scope.navigation._page - savedOptions._pageSize;
                    //} else {

                    idxArrayPersonsResults = $scope.navigation._page;

                    //}

                    $scope.stateParams_id = $scope.personsIds[idxArrayPersonsResults - 1];

                    // Sincronizar URL para que F5/compartir enlace mantengan la
                    // persona visible. notify=false evita re-instanciar el
                    // controlador (loadPerson más abajo ya recarga los datos).
                    // AB#2903.
                    if ($scope.stateParams_id != null
                            && String($scope.stateParams_id) !== String($stateParams.id)) {
                        $state.go('.', { id: $scope.stateParams_id }, { notify: false });
                    }

                    $scope.loadPerson(false);
                } else {
                    if(savedOptions != null) {
                        $scope.navigation._page = savedOptions.row_index + 1;
                        $scope.navigation._pages = savedOptions.totalRows;
                    }
                }
            };

            $scope.prepareNavigationBar();
            $scope.navigatePrevious = function () {
                if ($scope.navigation._page > 1) $scope.navigation._page--;
                $scope.prepareNavigationBar();
            };
            $scope.navigateNext = function () {
                if ($scope.navigation._page < $scope.navigation._pages) $scope.navigation._page++;
                $scope.prepareNavigationBar();
            };

            //cargamos datos auxiliares
            $scope.loadLanguages = function () {
                Restangular.all('Languages').getList({ active: true }).then(function (languages) {
                    $scope.selectLanguages = languages;
                });
            };

            $scope.loadLanguages();

            // Lista de parejas de autoridades
            $scope.loadAllPersons = function () {
                Restangular.all('Persons/AllPersons').getList().then(function (persons) {

                    $scope.couplePersons = persons;
                    $scope.couplePersons.unshift({
                        id: null,
                        name: $filter("translate")('persons.no_couple')
                    });

                });
            };

            $scope.genders = [
                { id: 'M', name: $filter("translate")('persons.gender_male') }, 
                { id: 'F', name: $filter("translate")('persons.gender_female') }, 
                { id: 'N', name: $filter("translate")('persons.gender_neutral') }
            ];

            $scope.selectedGender = $scope.genders.filter(pt => { return pt.id === 'M' })[0];

            $scope.loadGroups = function (reload) {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/Groups/GetGroupsPositions'
                }).then(function (results, status, headers, config) {
                    var data = treeService.groups(results.data.rows, null);
                    $scope.personGroups = data;
                    $rootScope.personGroups = data;
                });
            };

            $scope.loadGroups(false);

            $scope.loadPoliticalAffiliations = function (reload) {
                if (angular.isDefined($scope.politicalAffiliations) && !reload) return;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/PoliticalAffiliations'
                }).then(function (results, status, headers, config) {
                    $scope.politicalAffiliations = results.data.rows;
                });
            };

            $scope.loadContactTypes = function () {
                Restangular.all('PersonsContactsTypes').getList().then(function (results) {
                    $scope.contactTypes = results;
                });
            };

            $scope.loadCountries = function (reload) {
                if (angular.isDefined($scope.countries) && !reload) return;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/Countries'
                }).then(function (results, status, headers, config) {
                    $scope.countries = results.data.rows;
                    //valor de $scope.countries donde el code es 'ES'
                    $scope.defaultCountry = $scope.countries.find(country => country.code === 'ES');
                    if (angular.isDefined($scope.inlineEditItems['address']) && $scope.inlineEditItems['address'] != null) {
                        $scope.inlineEditItems['address'].country_id = $scope.defaultCountry.id;
                    }
                });
            };
            $scope.loadPersonsInformationsGroups = function () {
                var options = { entity_type: "persons" };
                Restangular.all('InformationsGroups').getList(options).then(function (personsInformationGroups) {
                    $scope.personsInformationGroups = personsInformationGroups;
                    $scope.personsInformationGroups.forEach(function (pig) {
                        if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                    });
                    $scope.checkboxSimpleOptions = [
                        { option: null, label: $filter('translate')('informations.all'), checked: true },
                        { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                        { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                    ];
                });
            };

            $scope.loadPersonsInformationsGroups();
            let loadConfigurationOptions = function () {
                let group_name = "Imágenes";
                Restangular.all('Configurations').getList({ code: "", group_name: group_name }).then(function (response) {
                    let configuration = response;
                    limit_image_width = configuration.filter(function (config) { return config.code == "LIMIT_IMAGE_WIDTH"; }).map(function (config) { return config.value; })[0];
                    limit_image_height = configuration.filter(function (config) { return config.code == "LIMIT_IMAGE_HEIGHT"; }).map(function (config) { return config.value; })[0];
                });
            }

            loadConfigurationOptions(); //Load image since from company_id
            $scope.selectImage = function () {

                $("#frmPersonImage").trigger("click");
                $("#frmPersonImage").change(function () {
                    const fileInput = document.querySelector('#frmPersonImage') as HTMLInputElement;
                    const file = fileInput?.files?.[0];
                    if (file) {
                        const fileReader = new FileReader();
                        /*
                            fileReader.onload = function (event) {
                                var uri = event.target.result;
                                if (angular.isUndefined($scope.person.FK_persons_images) || $scope.person.FK_persons_images == null) $scope.person.FK_persons_images = {};
                                $scope.person.FK_persons_images.image = uri;
                                $scope.person.photo = uri;
                                $scope.person.image_id = null; //??
                                $scope.changesNotSaved = true;
                                if(!$scope.$$phase) $scope.$apply();
                            };
                        */
                        fileReader.onload = function (event) {
                            if (!event.target) return;
                            const result = event.target.result;
                            if (typeof result !== 'string') return;
                            
                            const image = new Image();
                            image.src = result;
                            image.onload = function() {
                                if (limit_image_height != 0 && limit_image_width != 0) {
                                    // Check if image exceeds size limits
                                    if (image.width > limit_image_width || image.height > limit_image_height) {
                                        modalService.message({
                                            title: "Error",
                                            message: $filter('translate')('events.image_size_limit') + "<br>" + limit_image_width + "X" + limit_image_height,
                                            onAccept: function () { }
                                        });
                                    } else {
                                        if (angular.isUndefined($scope.person.FK_persons_images) || $scope.person.FK_persons_images == null) $scope.person.FK_persons_images = {};
                                        $scope.person.FK_persons_images.image = image.src;
                                        $scope.person.photo = image.src;
                                        $scope.person.image_id = null; //??
                                        $scope.changesNotSaved = true;
                                        if (!$scope.$$phase) $scope.$apply();
                                    }
                                } else {
                                    if (angular.isUndefined($scope.person.FK_persons_images) || $scope.person.FK_persons_images == null) $scope.person.FK_persons_images = {};
                                    $scope.person.FK_persons_images.image = image.src;
                                    $scope.person.photo = image.src;
                                    $scope.person.image_id = null; //??
                                    $scope.changesNotSaved = true;
                                    if (!$scope.$$phase) $scope.$apply();
                                }
                            };
                        };
                        fileReader.readAsDataURL(file);
                    } else {
                        // preview.src = "";
                    }
                });
            };

            $scope.getImage = function () {
                if ($scope.person.FK_persons_images != null && $scope.person.FK_persons_images.image != null) {
                    return $scope.person.FK_persons_images.image;
                } else if ($scope.person.image_id != null) {
                    return "/api/Image/GetImageBmp?id=" + $scope.person.image_id + "&maxW=150&maxH2=150";
                } else {
                    return "assets/img/no-user.jpeg";
                }
            };

            $scope.removeImage = function ($event) {
                $scope.person.image_id = null;
                $scope.person.photo = null;
                if ($scope.person.FK_persons_images != null) $scope.person.FK_persons_images.image = null;
                if (typeof ($event) !== "undefined") {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            };

            $scope.getGroupPath = function (group_id) {
                var ret = "";
                var groups = $filter("filter")($scope.personGroups, { id: group_id }, true);
                if (groups != null && groups.length > 0) {
                    var group = groups[0];
                    if (group.parent_group_id != null) {
                        var parentGroup = $scope.getGroupPath(group.parent_group_id);
                        ret = parentGroup + " > " + group.name;
                    } else {
                        var parentsGroups = $filter("filter")(group.FK_groups_groups_groups1, { child_group_id: group_id }, true);
                        if (parentsGroups.length > 0) {
                            var parentGroup1 = $scope.getGroupPath(parentsGroups[0].parent_group_id);
                            ret = parentGroup1 + " > " + group.name;
                        } else {
                            ret = group.name;
                        }
                    }
                }
                return ret;
            };

            $scope.savePerson = function () {
                // logService.debug(frmPerson);
                $scope.person.person_treatment_id = $scope.selectedTreatment.id;
                $scope.person.language_id = $scope.selectedLanguage.id;
                $scope.person.gender = $scope.selectedGender.id;
                if (!angular.isUndefined($scope.person.id)) {
                    //generamos pigs
                    var newPips = new Array();
                    angular.forEach($scope.personsInformationGroups, function (pig) {
                        var value = $scope.person.pigs[pig.id];
                        var pips = $filter("filter")(newPips, { information_group_id: pig.id });
                        if (pips.length > 0) {
                            var pip = pips[0];
                            pip.value = value;
                        } else {
                            var newPip = {
                                person_id: $scope.person.id,
                                entity_type: "persons",
                                entity_type_id: $scope.person.id,
                                information_group_id: pig.id,
                                value: value
                            };
                            newPips.push(newPip);
                        }
                    });

                    $scope.person.Information_groups_values_persons = newPips;
                    angular.forEach($scope.person.Information_groups_values_persons, function (pig) {
                        $scope.person.pigs[pig.information_group_id] = pig.value;
                    });

                    $scope.noneAllowedDialogCheck();
                    //Cuando es militar, hay que tener en cuenta que el position_order esta tratado inLine, hay que volver a poner todo el BigInt

                    $scope.person.put().then(function (result) {

                        if (typeof (result.id) != "undefined") {

                            if (angular.isUndefined($scope.callbackClose)) {
                                // $state.go("persons.list", { person_type: $scope.person_type, reset: true }); Para que se quede en la misma página.
                            } else {
                                $scope.callbackClose('cancel');
                            }
                            if ($scope.isAuthority == 'authority') {
                                toastr.success("Autoridad actualizada");
                            } else {
                                toastr.success("Personalidad actualizada");
                            }
                            $scope.loadPerson(false);
                            $scope.changesNotSaved = false;

                        } else {

                            $scope.errorMessage = result.message;

                        }
                    });
                } else {
                    //generamos pigs
                    var newPips = new Array();
                    angular.forEach($scope.personsInformationGroups, function (pig) {
                        var value = $scope.person.pigs[pig.id];
                        var pips = $filter("filter")(newPips, { information_group_id: pig.id });
                        if (pips.length > 0) {
                            var pip = pips[0];
                            pip.value = value;
                        } else {
                            var newPip = {
                                person_id: $scope.person.id,
                                entity_type: "persons",
                                entity_type_id: $scope.person.id,
                                information_group_id: pig.id,
                                value: value
                            };
                            newPips.push(newPip);
                        }
                    });
                    $scope.person.Information_groups_values_persons = newPips;
                    angular.forEach($scope.person.Information_groups_values_persons, function (pig) {
                        $scope.person.pigs[pig.information_group_id] = pig.value;
                    });
                    Restangular.all('Persons/CheckIfExists').post($scope.person).then(function (result) {
                        if (result) {
                            modalService.confirm({
                                title: $filter('translate')('persons.person_already_exist'),
                                message: $filter('translate')('persons.person_already_exist_message'),
                                onAccept: function () {
                                    $scope.createPerson();
                                }
                            });
                        } else {
                            $scope.createPerson();
                        }
                    });
                }
            };

            $scope.deletePerson = function () {
                    let name = $scope.person.name + " " + $scope.person.surname + (angular.isDefined($scope.person.lastname) && $scope.person.lastname != null ? " " + $scope.person.lastname : "");
                    modalService.confirm({
                        title: $filter('translate')('persons.button_delete'),
                        message: $filter('translate')('persons.delete_message') + " " + name + "?",
                        onAccept: function () {
                            Restangular.one('Persons', $scope.person.id).remove().then(function () {
                                toastr.success($filter('translate')('persons.delete_success'));
                                $state.go("persons.list", { person_type: $scope.stateParams_person_type, reset: false });
                            }, function (response) {
                                logService.error("Error with status code", response.status);
                                toastr.error($filter("translate")("general.delete_error_message"))
                            });
                        }
                    });
            };

            $scope.cancel = function () {
                if ($stateParams.coming_from_duplicates == true) {
                    $state.go("persons.duplicates_list");
                } else if (angular.isUndefined($scope.callbackClose)) {
                    $state.go("persons.list", { person_type: $scope.stateParams_person_type, reset: false });
                } else {
                    $scope.callbackClose('cancel');
                }
            };

            $scope.createPerson = function () {
                // logService.debug($scope.person);
                Restangular.all('persons').post($scope.person).then(function (result) {
                    if (angular.isDefined(result.id)) {

                        $scope.changesNotSaved = false;

                        if (angular.isUndefined($scope.callbackClose)) {
                            $state.go("persons.edit", { id: result.id });
                        } else {
                            // logService.debug("callbackCloseeee");
                            $scope.loadPerson(false);
                            $scope.callbackClose('cancel');
                        }

                        if ($scope.isAuthority == 'authority') {
                            toastr.success($filter('translate')('persons.authority_create_success'));
                        } else {
                            toastr.success($filter('translate')('persons.personality_create_success'));
                        }

                    }
                });
            };

            $scope.showActiveGroups = function (checked) {
            };

            //cargamos la visibilidad de los grupos asociados a la persona
            $scope.person_groups = {
                active: true //por defecto a true
            };

            $scope.person_groups_militar = {
                active: true //por defecto a true
            };

            //cargamos persona
            $scope.person = {
                acl: null,
                is_active: true,
                FK_persons_contacts_persons: [],
                FK_persons_private_fields_persons: [{}],
                FK_persons_addresses_persons: [],
                FK_persons_positions_persons: [],
                FK_persons_political_affiliations_persons: [],
                Information_groups_values_persons: [],
                FK_persons_mails_persons: [],
                FK_persons_positions: [],
                pigs: [],
                person_type: $stateParams.person_type
            };

            $scope.setChangesNotSaved = function (state, value) {
                if (value != null) {
                    $scope.changesNotSaved = state;
                }                
            };

            $scope.$watch('aclDialogState.savedVersion', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    $scope.person.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            $scope.loadPerson(false);
                            $scope.changesNotSaved = false;
                            toastr.success($filter('translate')('persons.acl_save_success'));
                        }
                    });
                }
            });

            // test

            // endtest

            $scope.loadPerson = function (reload) {
                if (!angular.isUndefined($scope.stateParams_id) && $scope.stateParams_id != null && $scope.stateParams_id != "") {
                    logService.debug("Loading person:", $scope.stateParams_id);
                    Restangular.one('Persons', $scope.stateParams_id).get().then(function (results) {
                        if (results.id != 0) {

                            $scope.person = results;
                            logService.debug("Person " + $scope.person.id + " loaded: " + $scope.person.name + " " + $scope.person.lastname, { 'person': $scope.person });
                            $scope.selectedTreatment = $scope.personTreatments.filter(pt => { return pt.id == $scope.person.person_treatment_id })[0];
                            $scope.selectedLanguage = $scope.selectLanguages.filter(pt => { return pt.id == $scope.person.language_id })[0];
                            $scope.selectedGender = $scope.genders.filter(pt => { return pt.id == $scope.person.gender })[0];

                            // Cargamos los permisos
                            GetAllowedUsers();
                            GetAllowedGroups();

                            //Comprobamos que tenga tratamiento, si no ponemos el que este por defecto
                            if (angular.isUndefined($scope.person.person_treatment_id) || $scope.person.person_treatment_id == null) {
                                const personDefault = $scope.personTreatments.filter(pt => { return pt.person_default });
                                $scope.person.person_treatment_id = personDefault[0].id;
                            }

                            $scope.person.FK_persons_positions = [];
                            $scope.person.FK_persons_positions.push({ person_position_id: null, position_id: null, position_name: 'Vacio' });
                            angular.forEach($scope.person.FK_persons_positions_persons, function (row) {

                                // Le metemos el tipo de posición
                                row.position_type = row.FK_persons_positions_positions.position_type;

                                let allPositionsPerson: any = {
                                    person_position_id: null,
                                    position_id: null,
                                    position_name: null,
                                    color_group: null
                                };

                                allPositionsPerson.person_position_id = row.id;
                                allPositionsPerson.position_id = row.position_id;

                                allPositionsPerson.color_group = row.FK_persons_positions_positions.FK_positions_groups.color;
                                allPositionsPerson.position_type = row.position_type;

                                if ($scope.person.gender == "M") {
                                    allPositionsPerson.position_name = row.FK_persons_positions_positions.male_description;
                                } else {
                                    if ($scope.person.gender == "F") {
                                        allPositionsPerson.position_name = row.FK_persons_positions_positions.female_description;
                                    } else {
                                        allPositionsPerson.position_name = row.FK_persons_positions_positions.name;
                                    }
                                }

                                $scope.person.FK_persons_positions.push(allPositionsPerson);

                                //Traemos las instituciones
                                if ($scope.person.FK_persons_positions.length > 0)
                                    getPositionsInstitutions($scope.person.FK_persons_positions_persons);

                                // Decimos si la mostramos o no
                                row.show = checkIfPositionIsVisible(row);

                            });

                            let options: any = {};
                            //Gestionamos duplicados

                            //Comprobamos si es un duplicado
                            if ($scope.person.duplicate_of != null) {
                                options.id = $scope.person.duplicate_of;
                                $scope.is_duplicate = true;
                                getParent();
                            } else {
                                options.id = $scope.person.id;
                            }

                            // Cargamos los tags
                            $scope.loadTags();

                            Restangular.all('Persons/DuplicatesGroup').getList(options).then(function (results) {

                                if (results.length > 0) {
                                    $scope.duplicates = results;
                                    if ($scope.is_duplicate) {
                                        $scope.duplicates = $scope.duplicates.filter(m => m.id != $scope.person.id)
                                    }
                                }

                            })
                        }

                        if (results.show_person_couple) $scope.loadAllPersons();

                        if (!reload) {
                            if ($rootScope.title.includes(" - ", 0)) {
                                $rootScope.title = $rootScope.title.split(" - ")[0] + " - " + results.name + " " + results.surname + (results.lastname != null ? " " + results.lastname : ""); //Ponemos el nombre en el titulo.
                                $rootScope.breadcrumb.pop(); //.splice(-1, 1);
                            } else {
                                $rootScope.title += " - " + results.name + " " + results.surname + (results.lastname != null ? " " + results.lastname : ""); //Ponemos el nombre en el titulo.
                            }
                            $rootScope.breadcrumb.push({ title: results.name + " " + results.surname + (results.lastname != null ? " " + results.lastname : "") });
                        }

                        if ($scope.person.birthdate != null) $scope.person.birthdate = new Date($scope.person.birthdate);
                        if ($scope.person.death_date != null) $scope.person.death_date = new Date($scope.person.death_date);

                        //generamos lista de valores de persons informations groups
                        $scope.person.pigs = [];
                        angular.forEach($scope.person.Information_groups_values_persons, function (pig) {
                            if (pig.FK_information_groups_values_information_groups.type == "checkboxSimple") {
                                $scope.person.pigs[pig.information_group_id] = pig.value; // (pig.value == "true" ? true : false);
                            } else if (pig.FK_information_groups_values_information_groups.type == "datetime") {
                                $scope.person.pigs[pig.information_group_id] = new Date(pig.value);
                            } else {
                                $scope.person.pigs[pig.information_group_id] = pig.value;
                            }

                        });
                    });
                } else {
                    $scope.person_groups = false;
                };
            }

            //No quitar esto, por que al crear nueva persona desde invitados, pilla antes esto que el ng-init y carga una persona por id de evento
            setTimeout(function () {
                if (angular.isDefined($scope.stateParams_id) && $scope.stateParams_id != "") {
                    $scope.loadPerson(false);
                }
            }, 100);

            //funciones de utilizar
            $scope.getRGB = function (hex) {
                var ret = "130,130,130";
                if (hex != null && hex != "") {
                    ret = parseInt(hex.replace("#", "").substring(0, 2), 16) + "," + parseInt(hex.replace("#", "").substring(2, 4), 16) + "," + parseInt(hex.replace("#", "").substring(4, 6), 16)
                }
                return ret;
            };

            $scope.prepareDates = function (obj) {
                for (var prop in obj) {
                    if (prop.indexOf("date") >= 0 && obj[prop] != null && typeof obj[prop] == "string") obj[prop] = new Date(obj[prop]);
                }
            };

            //cargamos cargos en grupo
            $scope.getPositions = function (group_id) {
                
                var positions = [];
                if (angular.isDefined($scope.personGroups)) {
                    var group = $filter('filter')($scope.personGroups, { id: group_id }, true)[0];
                    if (group != null) positions = group.FK_positions_groups;
                }
                return positions;
            };

            //Grids person position addresses y contacts
            $scope.gridPersonPositionAddresses = {
                pdfTitle: $filter('translate')('persons.addresses'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                enablePaginationControls: false,
                rowHeight: 45,
                minRowsToShow: 3,
                rowTemplate: '<div ng-dblclick="grid.appScope.addPositionsAddressDialog(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, exporterSuppressExport: true },

                    {
                        name: 'address_line_1', displayName: $filter('translate')('persons.address_line_1'), enableColumnMenu: false, enableFiltering: false, enableHiding: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.address_line_1}}<br/> {{row.entity.postal_code}}, {{row.entity.city}}</div>',
                    },
                    /*{ name: 'address_line_2', displayName: $filter('translate')('persons.address_line_2'), enableColumnMenu: false, enableFiltering: false, visible: false },
                    { name: 'postal_code', displayName: $filter('translate')('persons.postal_code'), enableColumnMenu: false, enableFiltering: false },
                    { name: 'city', displayName: $filter('translate')('persons.city'), enableColumnMenu: false, enableFiltering: false },
                    { name: 'state', displayName: $filter('translate')('persons.state'), enableColumnMenu: false, enableFiltering: false, enableHiding: false },*/
                    { name: 'notes', displayName: $filter('translate')('persons.notes'), visible: true },
                    {
                        name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                            { title: "", action: 'ng-click="grid.appScope.addPersonPositionsAddressDialog(row.entity)"', cssIconClass: "fa fa-edit" },
                            { title: "", action: 'ng-click="$event.stopPropagation();grid.appScope.deletePositionAddress(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    }
                ]
            }

            $scope.gridPersonPositionContactInfo = {
                pdfTitle: $filter('translate')('persons.contact_data'),
                exporterMenuCsv: true,
                enableGridMenu: false,
                enablePaginationControls: false,
                enableFiltering: false,
                minRowsToShow: 4,
                /*  paginationPageSizes: [1],
                  paginationPageSize: 1,*/
                rowTemplate: '<div ng-dblclick="grid.appScope.addPersonPositionsContactDialog(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                    $timeout(function () {
                        gridApi.grid.sortColumn(gridApi.grid.columns[3], uiGridConstants.ASC);
                        // gridApi.grid.sortColumn(gridApi.grid.columns[1], uiGridConstants.ASC,true);
                        gridApi.grid.notifyDataChange(uiGridConstants.dataChange.ALL);
                    });
                },
                columnDefs: [
                    { name: 'id', visible: false, enableColumnMenu: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'FK_persons_positions_contacts_positions_contacts_types.name', displayName: $filter('translate')('persons.contact_type'), enableHiding: false, enableColumnMenu: false },
                    { name: 'FK_persons_positions_contacts_positions_contacts_types.order', displayName: '', enableColumnMenu: false, enableHiding: false, visible: false },
                    { name: 'value', displayName: $filter('translate')('persons.value'), enableColumnMenu: false, enableFiltering: false, enableHiding: false },
                    { name: 'notes', displayName: $filter('translate')('persons.notes'), enableColumnMenu: false, enableFiltering: false, enableHiding: false, visible: false },
                    {
                        name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                            { title: "", action: 'ng-click="grid.appScope.addPersonPositionsContactDialog(row.entity)"', cssIconClass: "fa fa-edit" },
                            { title: "", action: 'ng-click="grid.appScope.deletePositionContactInfo(row.entity);" ng-if="grid.appScope.allowWrite" ', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    }
                ]
            }

            //funcion para cambiar elemento a edicion en linea
            $scope.inlineEditItems = {};
            $scope.inlineEdit = function (type, item, enable) {
                if (enable) {

                    if (angular.isUndefined(item.persons_position)) {
                        item.persons_position = $scope.person.FK_persons_positions.filter(m=>m.position_type == "civil");
                    }

                    if ((type == "mail" || type == "address" || type == "contact")  && item.persons_position.filter(m => m.person_position_id == null).length < 1) {
                        item.persons_position = [{ position_name: $filter('translate')('persons.contact.unassigned'), id: 0, person_position_id: null }, ...item.persons_position]; // Añadimos la opción sin asignar para indicar que no está asociado a ningún cargo. 
                    }

                    //cargamos datos necesarios segun tipo de entidad editada
                    if (type === "position") {
                        $scope.loadGroups(false);
                        $scope.newPosition = {
                            positionName: '',
                            groupName: item.FK_persons_positions_positions.FK_positions_groups.name,
                            position_type: item.position_type,
                            groupPath: '',
                            newPositionGroupId: null,
                            positionId: null
                        }

                        //$scope.newPosition.positionName = item.FK_persons_positions_positions.name;
                        //$scope.loadPersonsTreatments(false);

                        if (item.position_order != null) {
                            if (item.FK_persons_positions_positions.position_order != item.position_order) {
                                item.is_custom_position_order = true;
                            } else {
                                item.is_custom_position_order = false;
                                item.position_order = null;
                            }
                        } else {
                            item.is_custom_position_order = false;
                        }

                        if (item.position_order_article_10 != null) {
                            if (item.FK_persons_positions_positions.position_order_article_10 != item.position_order_article_10) {
                                item.is_custom_position_order_article_10 = true;
                            } else {
                                item.is_custom_position_order_article_10 = false;
                                item.position_order_article_10 = null;
                            }
                        } else {
                            item.is_custom_position_order_article_10 = false;
                        }
                        $scope.positionEdited = item.position_id;
                        $scope.gridPersonPositionAddresses.data = item.FK_persons_positions_addresses_positions;
                        $scope.gridPersonPositionContactInfo.data = item.FK_persons_positions_contacts_positions;

                        //$scope.gridPersonPositionContactInfo.gridApi.grid.notifyDataChange(uiGridConstants.dataChange.ALL);

                    } else if (type == "political-affiliation") {
                        $scope.loadPoliticalAffiliations(false);
                    } else if (type == "address") {
                        $scope.loadCountries(false);
                    } else if (type == "contact") {
                        $scope.loadContactTypes(false);
                    }

                    if (angular.isDefined($scope.inlineEditItems[type]) && $scope.inlineEditItems[type] != null) $scope.inlineEditItems[type].editMode = false;
                    var copy = JSON.parse(JSON.stringify(item));
                    item.editMode = true;
                    $scope.prepareDates(copy);

                    $scope.inlineEditItems[type] = copy; //copia, para no pasar cambios salvo que se guarde
                    $scope.inlineEditItems[type + "_orig"] = item; //objeto original
                    /*
                        if(type === "position" && item.position_id == null) {
                            $scope.loadPersonsTreatments(false).then(() => {
                                const personDefault = $scope.personTreatments.filter(pt => { return pt.person_default});
                                const positionDefault = $scope.personTreatments.filter(pt => { return pt.position_default});
                                if(personDefault !== undefined &&  personDefault.length > 0) {
                                    $scope.inlineEditItems['position'].person_treatment_id = personDefault[0].id;
                                }
                                if(positionDefault !== undefined && positionDefault.length > 0) {
                                    $scope.inlineEditItems['position'].position_treatment_id = positionDefault[0].id;
                                }
                            });
                         }
                    */
                } else {
                    $scope.inlineEditItems[type + "_orig"].editMode = false;
                    delete $scope.inlineEditItems[type];
                    delete $scope.inlineEditItems[type + "_orig"];
                }
                $rootScope.isInlineEditEnabled = enable;
            };

            // Al dar de alta un nuevo cargo, lo seleccionas, y al darle guardar, no te lo muestra. Despinchas el check de "ver activos" y entonces te lo muestra. Cambiarlo y q ese check no aplique hasta que guarde.
            // Simplemente con darle a guardar en la ficha de cliente, ya se aplica el cambio, por lo que lo que vamos a hacer es que cuando se cierre la ficha de añadir el cargo, se fuerce el guardado de la ficha de persona.
            $scope.savePersonPosition = function (item) {
                // TODO: Quitar esto si a Rodolfo le parece bien como ha quedado la pantalla
                /*
                 if($scope.newPosition.positionName != null && $scope.newPosition.positionId == null && $scope.newPosition.newPositionGroupId != null) {
                    let newPositionDto = {
                        id: "",
                        group_id: $scope.newPosition.newPositionGroupId,
                        name: $scope.newPosition.positionName,
                        male_description: $scope.newPosition.positionName,
                        female_description: $scope.newPosition.positionName,
                        FK_positions_tl_positions: [ {
                            id: "",
                            name: $scope.newPosition.positionName,
                            male_description: $scope.newPosition.positionName,
                            female_description: $scope.newPosition.positionName,
                            language_id: $rootScope.languageId
                        }],
                        FK_positions_contacts_positions: [],
                        FK_positions_addresses_positions: []
                    };
                    Restangular.all('positions').post(newPositionDto).then(function (result) {
                        logService.debug(result);
                    });
                }*/

                if (!angular.isUndefined($scope.person.id) && item != null) {
                    $scope.personPosition = item;
                    console.log($scope.person);
                    $scope.person.put().then(function (result) {
                        if (result.id === undefined) {
                            $scope.errorMessage = result.message;
                        } else {
                            $scope.loadPerson(false);
                        }
                    });
                }
            };

            $scope.positionSelect = function (item, model) {
                $scope.inlineEditItems['position'].FK_persons_positions_positions.position_treatment_id = item.position_treatment_id;
                $scope.inlineEditItems['position'].FK_persons_positions_positions.position_order = item.position_order;
                $scope.inlineEditItems['position'].FK_persons_positions_positions.position_order = item.position_order;
                if ($scope.inlineEditItems['position'].from_date != null) {
                    $scope.generatePositionOrderMilitar($scope.inlineEditItems['position'].from_date);
                } else {
                    $scope.generatePositionOrderMilitar(new Date());
                }                
            }

            $scope.generatePositionOrderMilitar = function (fromDate) {
                const initDateYear = new Date(1900, 0, 1);
                const initDateDays = new Date(new Date(fromDate).getFullYear(), 0, 1); 
                const todayDate = new Date(fromDate);

                const diffTimeYear = todayDate.getTime() - initDateYear.getTime();
                const diffTimeDays = todayDate.getTime() - initDateDays.getTime();
                const yearsFrom = Math.floor(diffTimeYear / (1000 * 3600 * 24 * 365.25));
                const daysFrom = Math.floor(diffTimeDays / (1000 * 3600 * 24));
                $scope.preferedGenerated = $scope.inlineEditItems['position'].FK_persons_positions_positions.position_order + " - " +yearsFrom.toString() + " - " + daysFrom.toString().padStart(3, "0");

            }

            $scope.saveInline = function (type) {
                //preparamos datos
                let originalItem = $scope.inlineEditItems[type + "_orig"];
                let item = $scope.inlineEditItems[type];
                originalItem.is_historic = true;

                if (type === "position") {
                    var group = $filter('filter')($scope.personGroups, { id: item.FK_persons_positions_positions.group_id }, true)[0];
                    if (group == null) return;
                    var position = $filter('filter')(group.FK_positions_groups, { id: item.position_id }, true)[0];
                    if (position == null) return;
                    if (angular.isUndefined(originalItem.id)) originalItem.id = null;

                    // Controlamos que solo pueda añadirse una position_militar 
                    if (position.position_type == "militar") {

                        logService.debug('$scope.person.FK_persons_positions_persons');
                        logService.debug($scope.person.FK_persons_positions_persons);

                        // Buscamos si tiene cargos militares activos 
                        let active_positions = $scope.person.FK_persons_positions_persons.filter(m => m.position_type == "militar" && m.FK_persons_positions_positions.FK_positions_groups.is_historic && m.id != position.id);

                        logService.debug('active_positions');
                        logService.debug(active_positions);

                        // Si los tiene solo se puede crear un cargo militar con fecha hasta anterior a hoy.
                        if (active_positions.length > 0 && (item.to_date == null || new Date(item.to_date).getTime() > Date.now()) && item.id == null) {
                            return modalService.message({
                                title: "Error",
                                message: $filter('translate')('persons.militar_position_error'),
                                onAccept: function () { }
                            });
                        }
                    }

                    let pos_order = null;
                    if (item.position_type == "militar") {
                        pos_order = ($scope.preferedGenerated + " - " + item.custom_position_order.toString().padStart(2, "0")).toString().replaceAll(' - ', '');
                    }                    

                    originalItem.position_id = position.id;
                    originalItem.FK_persons_positions_positions.name = position.name;
                    originalItem.FK_persons_positions_positions.group_id = group.id;
                    originalItem.FK_persons_positions_positions.FK_positions_groups.id = group.id;
                    originalItem.FK_persons_positions_positions.FK_positions_groups.name = group.name;
                    originalItem.FK_persons_positions_positions.FK_positions_groups.color = group.color;
                    originalItem.from_date = item.from_date;
                    originalItem.to_date = item.to_date;
                    originalItem.position_order = item.position_type == "militar" ? Number(pos_order):item.position_order;
                    originalItem.position_order_article_10 = item.position_order_article_10;
                    originalItem.person_treatment_id = item.person_treatment_id;
                    originalItem.position_treatment_id = item.position_treatment_id;
                    originalItem.program_emails = item.program_emails;
                    originalItem.invitation_emails = item.invitation_emails;
                    originalItem.FK_persons_positions_addresses_positions = item.FK_persons_positions_addresses_positions;
                    originalItem.FK_persons_positions_contacts_positions = item.FK_persons_positions_contacts_positions;

                    // $log.debug(originalItem);
                    if (!item.is_custom_position_order && item.position_type != "militar") originalItem.position_order = null;
                    
                    $scope.savePersonPosition(originalItem);
                    $scope.changesNotSaved = true;

                } else if (type === "political-affiliation") {

                    // logService.debug(item);
                    //var politicalAffiliation = item.FK_persons_political_affiliations_political_affiliations;

                    if (angular.isUndefined(originalItem.id)) originalItem.id = null;
                    originalItem.political_affiliation_id = item.FK_persons_political_affiliations_political_affiliations.id;
                    originalItem.from_date = item.from_date;
                    originalItem.to_date = item.to_date;
                    originalItem.political_affiliation_zone_id = (item.FK_persons_political_affiliations_political_affiliations_zones != null ? item.FK_persons_political_affiliations_political_affiliations_zones.id : null);

                    originalItem.FK_persons_political_affiliations_political_affiliations = item.FK_persons_political_affiliations_political_affiliations;
                    originalItem.FK_persons_political_affiliations_political_affiliations_zones = item.FK_persons_political_affiliations_political_affiliations_zones;

                    $scope.changesNotSaved = true;

                } else if (type === "address") {
                    let country = $filter('filter')($scope.countries, { id: item.country_id.id }, true)[0];
                    if (angular.isUndefined(originalItem.id)) originalItem.id = null;
                    originalItem.country_id = item.country_id;
                    originalItem.address_line_1 = item.address_line_1;
                    originalItem.address_line_2 = item.address_line_2;
                    originalItem.postal_code = item.postal_code;
                    originalItem.city = item.city;
                    originalItem.state = item.state;
                    originalItem.notes = item.notes;
                    originalItem.FK_persons_addresses_countries.code = country.code;
                    originalItem.FK_persons_addresses_countries.name = country.name;
                    originalItem.value = item.value;
                    originalItem.person_position_id = item.person_position_id;
                    $scope.person.FK_persons_addresses_persons[0].is_historic = true;
                    $scope.changesNotSaved = true;
                } else if (type === "contact") {
                    var contactType = $filter('filter')($scope.contactTypes, { id: item.person_contact_type_id.id }, true)[0];
                    if (angular.isUndefined(originalItem.id)) originalItem.id = null;
                    originalItem.person_contact_type_id = contactType.id;
                    originalItem.notes = item.notes;
                    originalItem.FK_persons_contacts_persons_contacts_types.code = contactType.code;
                    originalItem.FK_persons_contacts_persons_contacts_types.name = contactType.name;
                    originalItem.value = item.value;
                    originalItem.person_position_id = item.person_position_id;
                    $scope.person.FK_persons_contacts_persons[0].is_historic = true;
                    $scope.changesNotSaved = true;
                } else if (type === "mail") {
                    if (angular.isUndefined(originalItem.id)) originalItem.id = null;
                    originalItem.email = item.email;
                    originalItem.use_for_invitation = item.use_for_invitation;
                    originalItem.use_for_program = item.use_for_program;
                    originalItem.use_for_others = item.use_for_others;
                    originalItem.person_position_id = item.person_position_id;
                    //$scope.person.FK_persons_mails_persons[0].is_historic = true;

                    $scope.changesNotSaved = true;
                }

                $scope.inlineEdit(type, originalItem, false);
            };
            $scope.cancelInline = function (type) {

                $scope.inlineEditItems[type + "_orig"].editMode = false;
                $scope.inlineEditItems[type] = $scope.inlineEditItems[type + "_orig"];
                // logService.debug(angular.isDefined($scope.inlineEditItems[type].id));
                if (angular.isDefined($scope.inlineEditItems[type].id)) {
                    //si tiene id definido (cuando es nuevo se pone a null al guardar inline), cancelamos edicion
                    $scope.inlineEdit(type, $scope.inlineEditItems[type], false);
                } else {
                    //si no tiene, estabamos añadiendo, borramos
                    $scope.deleteInline(type);
                }

            };

            $scope.deleteInline = function (type) {

                var orig = $scope.inlineEditItems[type + "_orig"];
                // logService.debug("deleteInline", type, orig);
                if (type === "position") {
                    var idx = $scope.person.FK_persons_positions_persons.indexOf(orig);
                    $scope.person.FK_persons_positions_persons.splice(idx, 1);
                } else if (type === "political-affiliation") {
                    var idx = $scope.person.FK_persons_political_affiliations_persons.indexOf(orig);
                    $scope.person.FK_persons_political_affiliations_persons.splice(idx, 1);
                } else if (type === "address") {
                    var idx = $scope.person.FK_persons_addresses_persons.indexOf(orig);
                    $scope.person.FK_persons_addresses_persons.splice(idx, 1);
                } else if (type === "contact") {
                    var idx = $scope.person.FK_persons_contacts_persons.indexOf(orig);
                    $scope.person.FK_persons_contacts_persons.splice(idx, 1);
                } else if (type === "mail") {
                    var idx = $scope.person.FK_persons_mails_persons.indexOf(orig);
                    $scope.person.FK_persons_mails_persons.splice(idx, 1);
                }

                $scope.inlineEdit(type, $scope.inlineEditItems[type], false);
                $scope.changesNotSaved = true;

            };

            $scope.newPosition = {
                positionName: '',
                groupName: '',
                groupPath: '',
                newPositionGroupId: null,
                positionId: null
            }

            $scope.positionAdded = {};

            $scope.addPersonPosition = function (position_type) {
                if (angular.isUndefined($scope.person.id)) {
                    modalService.message({
                        title: $filter('translate')('groups.warning'),
                        message: "Debe guardar antes la autoridad para poder asignarle cargos.",//$filter('translate')('cms_categories.delete_message_children_error'),
                        onAccept: function () { }
                    });
                } else {
                    var position = {
                        position_id: null,
                        position_type: position_type,
                        person_id: $scope.person.id,
                        FK_persons_positions_addresses_positions: [],
                        FK_persons_positions_contacts_positions: [],
                        FK_persons_positions_positions: {
                            name: null,
                            FK_positions_groups: {
                                name: null
                            },
                            from_date: null,
                            to_date: null,
                        }
                    };
                    $scope.person.FK_persons_positions_persons.push(position);
                    $scope.inlineEdit("position", position, true);
                }
            };

            $scope.getPositionsSearch = function (val) {
                let param = '';
                if ($scope.newPosition.newPositionGroupId != null) {
                    param = '?related_entity_id=' + $scope.newPosition.newPositionGroupId;
                }
                return Restangular.all('search/position/' + val + param).getList().then(function (searchTerms) {
                    return searchTerms;
                });
            };

            $scope.getGroupsSearch = function (val) {

                logService.debug('$scope.newPosition');
                logService.debug($scope.newPosition);

                if ($scope.newPosition.position_type == 'militar') {

                    return Restangular.all('search/group_militar/' + val).getList().then(function (searchTerms) {
                        return searchTerms;
                    });

                } else {
                    return Restangular.all('search/group/' + val).getList().then(function (searchTerms) {
                        return searchTerms;
                    });
                }
            };

            $scope.positionSelected = function ($item, $model, $label) {

                $scope.inlineEditItems['position'].position_id = $item.id;
                $scope.positionAdded = {
                    id: $item.id,
                    name: $item.term,

                    groupId: $item.related_entity_id,
                    groupName: $item.related_term
                }
                $scope.newPosition.positionName = $item.term;
                $scope.newPosition.positionId = $item.id;

            };

            $scope.groupSelected = function ($item, $model, $label) {

                $scope.inlineEditItems['position'].FK_persons_positions_positions.group_id = $item.id;
                $scope.newPosition.groupPath = $item.related_term;

            };

            $scope.addPoliticalAffiliationDialog = function () {

                var politicalAffiliation = {
                    political_affiliation_id: null,
                    political_affiliation_zone_id: null,
                    person_id: $scope.person.id,
                };

                $scope.person.FK_persons_political_affiliations_persons.push(politicalAffiliation);

                $timeout(function () {
                    $scope.inlineEdit("political-affiliation", politicalAffiliation, true);
                }, 200);

            };

            $scope.addAddress = function () {

                var address = {

                    country_id: null,
                    person_id: $scope.person.id,
                    address_line_1: null,
                    address_line_2: null,
                    state: null,
                    postal_code: null,
                    city: null,
                    notes: null,

                    FK_persons_addresses_countries: {
                        code: null,
                        name: null
                    },

                    persons_position: $scope.person.FK_persons_positions.filter(m => m.position_type == "civil")

                };

                $scope.person.FK_persons_addresses_persons.push(address);
                $timeout(function () {
                    $scope.inlineEdit("address", address, true);
                }, 200);

            };

            $scope.addContact = function () {

                var contact = {
                    contact_type_id: null,
                    person_id: $scope.person.id,
                    value: null,
                    from_position: false,
                    FK_persons_contacts_persons_contacts_types: {
                        name: null
                    },
                    persons_position: $scope.person.FK_persons_positions.filter(m => m.position_type == "civil")
                };

                $scope.person.FK_persons_contacts_persons.push(contact);
                $timeout(function () {
                    $scope.inlineEdit("contact", contact, true);
                }, 200);

            };

            $scope.addMail = function () {
                var mail = {
                    person_id: $scope.person.id,
                    email: null,
                    use_for_invitation: true,
                    use_for_program: true,
                    use_for_others: true,
                    persons_position: $scope.person.FK_persons_positions.filter(m => m.position_type == 'civil')
                };

                $scope.person.FK_persons_mails_persons.push(mail);

                $timeout(function () {
                    $scope.inlineEdit("mail", mail, true);
                }, 200);
            };

            $scope.addNewPosition = function (position) {

                var item = $scope.inlineEditItems['position'];
                if (item.FK_persons_positions_positions.group_id == null) return;
                $scope.addNewGroup(item.FK_persons_positions_positions.group_id);

            };

            $scope.addNewGroup = function (group_id) {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddGroupModalView,
                    controller: "AddNewGroupModalCtrl",
                    size: "lg",
                    resolve: {
                        group_id: function () {
                            return group_id;
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                    // logService.debug(result);
                    angular.forEach($scope.person.FK_persons_positions_persons, function (personPosition) {
                        if (personPosition.FK_persons_positions_positions.FK_positions_groups.id == result.id) {
                            personPosition.FK_persons_positions_positions.FK_positions_groups.name = result.name;
                            personPosition.FK_persons_positions_positions.FK_positions_groups.color = result.color;
                            personPosition.FK_persons_positions_positions.FK_positions_groups.FK_groups_tl_groups = result.FK_positions_groups.FK_groups_tl_groups;
                        }
                    });
                    $scope.loadGroups(true);
                    // Se recarga de nuevo la persona
                    //                    $scope.loadPerson(false);
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });

            };

            $scope.editGroup = function ($event, group) {
                $event.stopPropagation();
                // logService.debug(group);
                $scope.addNewGroup(group.id);
            };
            $scope.editPosition = function ($event, position) {

                $event.stopPropagation();
                /*                var groups = $filter("filter")($scope.personGroups, { id: $scope.inlineEditItems['position'].FK_persons_positions_positions.group_id }, true);
                                logService.debug(groups);*/
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: PositionModalView,
                    controller: "PositionModalCtrl",
                    size: 'lg',
                    resolve: {
                        position: function () {
                            return position;
                        }, position_list: function () {
                            return null;
                        }, group: function () {
                            return null;
                        }, fromView: function () {
                            return "Persons";
                        }
                    }

                });
                $modalInstance.result.then(function (resultModal) {
                    var resultvalue = resultModal.edited;
                    Restangular.all("positions/" + resultvalue.id).customPUT(resultvalue).then(function (result) {
                        //buscamos referencia y reemplazamos completa
                        angular.forEach($scope.person.FK_persons_positions_persons, function (personPosition) {
                            if (personPosition.FK_persons_positions_positions.id == result.id) {
                                personPosition.FK_persons_positions_positions.name = result.name;
                                personPosition.FK_persons_positions_positions.notes = result.notes;
                                personPosition.FK_persons_positions_positions.institution = result.institution;
                                personPosition.FK_persons_positions_positions.invitation_emails = result.invitation_emails;
                                personPosition.FK_persons_positions_positions.program_emails = result.program_emails;
                                personPosition.FK_persons_positions_positions.position_order = result.position_order;
                                personPosition.FK_persons_positions_positions.position_treatment_id = result.position_treatment_id;
                                // Quizás funcione
                                personPosition.FK_persons_positions_positions.position_order_article_10 = result.position_order_article_10;
                                personPosition.FK_persons_positions_positions.FK_positions_tl_positions = result.FK_positions_tl_positions;
                                personPosition.FK_persons_positions_positions.FK_positions_addresses_positions = result.FK_positions_addresses_positions;
                                personPosition.FK_persons_positions_positions.FK_positions_contacts_positions = result.FK_positions_contacts_positions;
                                $scope.inlineEditItems["position"].FK_persons_positions_positions.position_treatment_id = personPosition.FK_persons_positions_positions.position_treatment_id;
                                $scope.inlineEditItems['position'].FK_persons_positions_positions.position_order = result.position_order;
                                $scope.inlineEditItems['position'].FK_persons_positions_positions.position_order_article_10 = result.position_order_article_10;
                                $scope.generatePositionOrderMilitar(new Date());
                            }
                        });
                        $scope.loadGroups();
                        // Se recarga de nuevo la persona
                        //$scope.loadPerson(false);
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.addPersonPositionsAddressDialog = function (personPositionAddress) {

                var editedIdx = 0;

                if ($scope.gridPersonPositionAddresses.data != null) editedIdx = $scope.gridPersonPositionAddresses.data.indexOf(personPositionAddress);

                if (angular.isUndefined(personPositionAddress)) personPositionAddress = { isNew: true };

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: PersonPositionAddressModalView,
                    controller: "PersonPositionAddressModalCtrl",
                    resolve: {
                        personPositionAddress: function () {
                            return personPositionAddress;
                        }
                    }
                });

                //Response del modal
                $modalInstance.result.then(function (data) {
                    var personPositionAddressValue = data.edited;
                    if (angular.isUndefined(personPositionAddressValue.state)) personPositionAddressValue.state = "";
                    if (angular.isUndefined(personPositionAddressValue.postal_code)) personPositionAddressValue.postal_code = "";
                    if (angular.isUndefined(personPositionAddressValue.address_line_2)) personPositionAddressValue.address_line_2 = "";
                    if (angular.isUndefined(personPositionAddressValue.notes)) personPositionAddressValue.notes = "";

                    if ((angular.isDefined(personPositionAddressValue.address_line_1) && personPositionAddressValue.address_line_1 != "" && personPositionAddressValue.address_line_1 != null) &&
                        (angular.isDefined(personPositionAddressValue.city) && personPositionAddressValue.city != "" && personPositionAddressValue.city != null)) {
                        if (!angular.isUndefined(personPositionAddressValue.FK_persons_positions_addresses_countries.selected) && personPositionAddressValue.FK_persons_positions_addresses_countries.selected !== null) {

                            var person_positions_address = {
                                FK_persons_positions_addresses_countries: angular.copy(personPositionAddressValue.FK_persons_positions_addresses_countries.selected),
                                country_id: personPositionAddressValue.FK_persons_positions_addresses_countries.selected.id,
                                address_line_1: personPositionAddressValue.address_line_1,
                                city: personPositionAddressValue.city,
                                state: personPositionAddressValue.state,
                                postal_code: personPositionAddressValue.postal_code,
                                address_line_2: personPositionAddressValue.address_line_2,
                                notes: personPositionAddressValue.notes
                            };
                            if (personPositionAddressValue.isNew) {
                                $scope.inlineEditItems['position'].FK_persons_positions_addresses_positions.push(person_positions_address);
                                $scope.gridPersonPositionAddresses.data = $scope.inlineEditItems['position'].FK_persons_positions_addresses_positions;
                            } else {
                                $scope.gridPersonPositionAddresses.data[editedIdx] = person_positions_address;
                                $scope.inlineEditItems['position'].FK_persons_positions_addresses_positions[editedIdx] = person_positions_address;
                            }

                            if (!$scope.$$phase) $scope.$apply();
                        }

                    }

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            };

            $scope.addPersonPositionsContactDialog = function (personPositionContactInfo) {
                var editedIdx = 0;
                if ($scope.gridPersonPositionContactInfo.data != null) editedIdx = $scope.gridPersonPositionContactInfo.data.indexOf(personPositionContactInfo);

                if (angular.isUndefined(personPositionContactInfo)) personPositionContactInfo = { isNew: true };

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: PersonPositionContactModalView,
                    controller: "PersonPositionContactModalCtrl",
                    resolve: {
                        personPositionContactInfo: function () {
                            return personPositionContactInfo;
                        }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {

                    var personPositionContactValue = data.edited;
                    // logService.debug(personPositionContactValue);
                    if (angular.isUndefined(personPositionContactValue.notes)) personPositionContactValue.notes = "";

                    if (angular.isDefined(personPositionContactValue.value) && personPositionContactValue.value !== "" && personPositionContactValue.value !== null) {
                        if (!angular.isUndefined(personPositionContactValue.FK_persons_positions_contacts_positions_contacts_types.selected) && personPositionContactValue.FK_persons_positions_contacts_positions_contacts_types.selected !== null) {
                            var person_positions_contacts = {
                                FK_persons_positions_contacts_positions_contacts_types: angular.copy(personPositionContactValue.FK_persons_positions_contacts_positions_contacts_types.selected),
                                person_position_contact_type_id: personPositionContactValue.FK_persons_positions_contacts_positions_contacts_types.selected.id,
                                value: personPositionContactValue.value,
                                notes: personPositionContactValue.notes
                            };

                            if (personPositionContactValue.isNew) {
                                $scope.inlineEditItems['position'].FK_persons_positions_contacts_positions.push(person_positions_contacts);
                                $scope.gridPersonPositionContactInfo.data = $scope.inlineEditItems['position'].FK_persons_positions_contacts_positions;
                            } else {
                                $scope.inlineEditItems['position'].FK_persons_positions_contacts_positions[editedIdx] = person_positions_contacts;
                                $scope.gridPersonPositionContactInfo.data[editedIdx] = person_positions_contacts;
                            }

                            if (!$scope.$$phase) $scope.$apply();

                        }

                    }

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            };

            // Gestión de duplicados
            // Navegación
            let getParent = function () {
                Restangular.one('Persons', $scope.person.duplicate_of).get().then((results) => {
                    $scope.parent = results;
                })
            };

            $scope.goToDuplicate = function (person) {
                $state.go("persons.edit", { person_type: person.person_type, id: person.id, coming_from_duplicates: $stateParams.coming_from_duplicates });
            };

            $scope.goToParent = function () {
                $state.go("persons.edit", { person_type: $scope.parent.person_type, id: $scope.parent.id, coming_from_duplicates: $stateParams.coming_from_duplicates });
            };

            //Mergeo de dato
            //Función general

            let mergeKeys = function (mergeFrom, mergeTo, keysToMerge) {

                let keys = Object.keys(mergeFrom)

                keys.forEach(key => {
                    if (keysToMerge.includes(key)) {
                        if (!mergeTo[key] || mergeTo[key] == "") {
                            mergeTo[key] = mergeFrom[key];
                        }
                    }
                });

                return mergeTo;
            }

            // Funciones específicas
            $scope.mergeMainData = function () {

                modalService.confirm({
                    title: $filter('translate')('persons.push_to_parent'),
                    message: $filter('translate')('persons.push_to_parent_message'),
                    onAccept: function () {

                        let keysToMerge = ['name', 'surname', 'lastname', 'num_identification', 'birthdate',
                            'death_date', 'gender', 'language_id', 'couple_person_id', 'not_accept_gifts', 'notes'];

                        $scope.parent = mergeKeys($scope.person, $scope.parent, keysToMerge);

                        $scope.parent.put().then(function (result) {

                            if (typeof (result.id) != "undefined") {
                                toastr.success($filter('translate')('persons.push_to_parent_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }
                });

            };

            // Gestión de instituciones 
            let getPositionsInstitutions = function (person_position_list) {

                let institutionsIdList = person_position_list.map(pp => pp.FK_persons_positions_positions.institution_id);
                // Recogemos las instituciones pertinentes
                Restangular.all('Institutions').getList(institutionsIdList).then(function (result) {
                    // Filtramos los resultados 
                    result = result.filter(r => institutionsIdList.includes(r.id));
                    // Las asociamos a cada Cargo
                    person_position_list.forEach(function (personPosition) {
                        if (personPosition.FK_persons_positions_positions.institution_id)
                            personPosition.FK_positions_institution = result.filter(r => r.id == personPosition.FK_persons_positions_positions.institution_id).pop();
                    })

                });
            };

            $scope.mergePositions = function (position) {

                event.stopPropagation();

                modalService.confirm({
                    title: $filter('translate')('persons.push_to_parent'),
                    message: $filter('translate')('persons.push_to_parent_message'),
                    onAccept: function () {

                        let index = $scope.person.FK_persons_positions_persons.indexOf(position);
                        position.person_id = $scope.parent.id;
                        $scope.person.FK_persons_positions_persons.splice(index, 1);
                        $scope.parent.FK_persons_positions_persons.push(position)

                        $scope.parent.put().then(function (result) {

                            if (typeof (result.id) != "undefined") {
                                toastr.success($filter('translate')('persons.push_to_parent_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });

                    }
                });
            };

            $scope.mergePoliticalAffiliations = function (affiliation) {
                event.stopPropagation()

                modalService.confirm({
                    title: $filter('translate')('persons.push_to_parent'),
                    message: $filter('translate')('persons.push_to_parent_message'),
                    onAccept: function () {

                        let index = $scope.person.political_affiliations.indexOf(affiliation);
                        affiliation.person_id = $scope.parent.id;
                        $scope.person.political_affiliations.splice(index, 1);
                        $scope.parent.political_affiliations.push(affiliation)

                        $scope.parent.put().then(function (result) {

                            if (typeof (result.id) != "undefined") {
                                toastr.success($filter('translate')('person.push_to_parent_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }
                });
            };

            $scope.mergeMails = function (mail) {
                event.stopPropagation()

                modalService.confirm({
                    title: $filter('translate')('persons.push_to_parent'),
                    message: $filter('translate')('persons.push_to_parent_message'),
                    onAccept: function () {

                        let index = $scope.person.FK_persons_mails_persons.indexOf(mail);
                        $scope.person.FK_persons_mails_persons.splice(index, 1);
                        mail.person_id = $scope.parent.id;
                        $scope.parent.FK_persons_mails_persons.push(mail);

                        $scope.parent.put().then(function (result) {

                            if (typeof (result.id) != "undefined") {
                                toastr.success($filter('translate')('person.push_to_parent_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }
                });
            };

            $scope.mergeAddresses = function (address) {
                event.stopPropagation()

                modalService.confirm({
                    title: $filter('translate')('persons.push_to_parent'),
                    message: $filter('translate')('persons.push_to_parent_message'),
                    onAccept: function () {

                        let index = $scope.person.FK_persons_addresses_persons.indexOf(address);
                        address.person_id = $scope.parent.id;
                        $scope.person.FK_persons_addresses_persons.splice(index, 1);
                        $scope.parent.FK_persons_addresses_persons.push(address)

                        $scope.parent.put().then(function (result) {

                            if (typeof (result.id) != "undefined") {
                                toastr.success($filter('translate')('person.push_to_parent_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }
                });
            };

            $scope.mergeContacts = function (contact) {
                event.stopPropagation()

                modalService.confirm({
                    title: $filter('translate')('persons.push_to_parent'),
                    message: $filter('translate')('persons.push_to_parent_message'),
                    onAccept: function () {

                        let index = $scope.person.FK_persons_contacts_persons.indexOf(contact);
                        contact.person_id = $scope.parent.id;
                        $scope.person.FK_persons_contacts_persons.splice(index, 1);

                        $scope.parent.FK_persons_contacts_persons.push(contact)

                        $scope.parent.put().then(function (result) {

                            if (typeof (result.id) != "undefined") {
                                toastr.success($filter('translate')('person.push_to_parent_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }
                });
            };
            $scope.deletePositionContactInfo = function (entity) {
                var editedIdx = $scope.gridPersonPositionContactInfo.data.indexOf(entity);
                $scope.gridPersonPositionContactInfo.data.splice(editedIdx, 1);
                $scope.inlineEditItems['position'].FK_persons_positions_contacts_positions.splice(editedIdx, 1);
            }

            $scope.deletePositionAddress = function (entity) {
                var editedIdx = $scope.gridPersonPositionAddresses.data.indexOf(entity);
                $scope.gridPersonPositionAddresses.data.splice(editedIdx, 1);
                $scope.inlineEditItems['position'].FK_persons_positions_addresses_positions.splice(editedIdx, 1);
            }

            $scope.openAttendedEvents = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AttendedEventsModalView,
                    controller: "AttendedEventsModalCtrl",
                    resolve: {
                        person_id: function () {
                            return $scope.person.id;
                        }
                    },
                    size: 'lg'
                });

                $modalInstance.result.then(function () {

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            };


            $scope.openAllowedUsers = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AllowedUsersModalView,
                    controller: "AllowedUsersModalCtrl",
                    scope: $scope,
                    resolve: {
                        person_id: function () {
                            return $scope.person.id;
                        }
                    },
                    size: 'lg'
                });

                $modalInstance.result.then(function () {

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });


            };

            $scope.printPDF = function () {

                $("#elementHideForPrint").hide();
                $("#elementHideForPrintBtn1").hide();
                $("#elementHideForPrintBtn2").hide();
                $("#elementHideForPrintBtn3").hide();
                $("#elementHideForPrintBtn4").hide();
                $("#elementHideForPrintBtn5").hide();
                $("#elementHideForPrintBtn6").hide();

                $scope.tableResultsExport = true;

                html2canvas(document.querySelector("#documentPrint")).then(canvas => {
                    var data = canvas.toDataURL("image/png", 1.0);
                    $(".modal").css("height", "");
                    var docDefinition = {
                        pageSize: {
                            width: canvas.width + 100,
                            height: canvas.height + 200
                        },
                        content: [{
                            image: data,
                            width: canvas.width
                        }]
                    };
                    //@ts-ignore
                    pdfMake.createPdf(docDefinition).download("ficha_autoridad.pdf");

                    $("#elementHideForPrint").show();
                    $("#elementHideForPrintBtn1").show();
                    $("#elementHideForPrintBtn2").show();
                    $("#elementHideForPrintBtn3").show();
                    $("#elementHideForPrintBtn4").show();
                    $("#elementHideForPrintBtn5").show();
                    $("#elementHideForPrintBtn6").show();

                });
            };

            $scope.foldersFiles = function () {
                foldersService.folders("persons", $scope.person.id, false);
            };

            //<editor-fold desc="Operaciones con emails">
            $scope.movePersonMailToPosition = function ($event, person_mail_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePersonMailToPosition/", person_mail_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.movePositionMailToPerson = function ($event, position_mail_id, person_position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePositionMailToPerson/" + position_mail_id, person_position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.moveInstitutionMailToPosition = function ($event, institution_mail_id, position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MoveInstitutionMailToPosition/" + institution_mail_id, position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.movePositionMailToInstitution = function ($event, position_mail_id, institution_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePositionMailToInstitution/" + position_mail_id, institution_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deletePersonMail = function ($event, person_mail_id) {
                $event.stopPropagation();
                modalService.confirm({
                    title: $filter('translate')('persons.delete_person_mail_header'),
                    message: $filter('translate')('persons.delete_person_mail_header_message'),
                    onAccept: function () {
                        Restangular.one("Persons/DeletePersonMail", person_mail_id).remove().then(function () {
                            toastr.success($filter('translate')('persons.email_deleted'));
                            $scope.loadGroups();
                            $scope.loadPerson(true);
                        });
                    }
                });

            };

            $scope.deletePositionEmails = function ($event, position_mail_id) {
                $event.stopPropagation();
                Restangular.one("Persons/DeletePositionEmails/", position_mail_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deleteInstitutionEmails = function ($event, institution_mail_id) {
                $event.stopPropagation();
                Restangular.one("Persons/DeleteInstitutionMail/", institution_mail_id).remove().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });

            }
            //</editor-fold>

            //<editor-fold desc="Operaciones con direcciones">
            $scope.movePersonAddressToPosition = function ($event, person_address_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePersonAddressToPosition/" + person_address_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.movePositionAddressToPerson = function ($event, address_id, person_position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePositionAddressToPerson/" + address_id + "/" + person_position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.moveInstitutionAddressToPosition = function ($event, institution_address_id, position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MoveInstitutionAddressToPosition/" + institution_address_id + "/" + position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.movePositionAddressToInstitution = function ($event, position_address_id, institution_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePositionAddressToInstitution/" + position_address_id + "/" + institution_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deletePersonAddress = function ($event, person_address_id) {
                $event.stopPropagation();
                Restangular.one("Persons/DeletePersonAddress", person_address_id).remove().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deletePositionAddress = function ($event, address_id) {
                $event.stopPropagation();
                Restangular.one("Persons/DeletePositionAddress", address_id).remove().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deleteInstitutionAddress = function ($event, address_id) {
                $event.stopPropagation();
                Restangular.one("Persons/DeleteInstitutionAddress", address_id).remove().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };
            //</editor-fold>

            //<editor-fold desc="Operaciones con datos de contacto">
            $scope.movePositionContactToPerson = function ($event, contact_id, person_position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePositionContactToPerson/" + contact_id + "/" + person_position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.movePersonContactToPosition = function ($event, person_contact_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePersonContactToPosition/" + person_contact_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.moveInstitutionContactToPosition = function ($event, institution_contact_id, position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MoveInstitutionContactToPosition/" + institution_contact_id + "/" + position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.movePositionContactToInstitution = function ($event, position_contact_id, institution_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MovePositionContactToInstitution/" + position_contact_id + "/" + institution_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deletePersonContact = function ($event, person_contact_id) {
                $event.stopPropagation();
                Restangular.one("Persons/DeletePersonContact", person_contact_id).remove().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deletePositionContact = function ($event, contact_id) {
                // logService.debug("deletePositionContact contact_id: ", contact_id);
                $event.stopPropagation();
                Restangular.one("Persons/DeletePositionContact", contact_id).remove().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deleteInstitutionContact = function ($event, contact_id) {
                // logService.debug("deletePositionContact contact_id: ", contact_id);
                $event.stopPropagation();
                Restangular.one("Persons/DeleteInstitutionContact", contact_id).remove().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            /* Operaciones con la precedencia */
            $scope.deletePositionOrder = function ($event, position_id) {
                // logService.debug("deletePersonPositionOrder position_id: ", position_id);
                $event.stopPropagation();
                Restangular.one("Persons/DeletePositionOrder/" + position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.deletePersonPositionOrder = function ($event, position_id) {
                // logService.debug("deletePersonPositionOrder position_id: ", position_id);
                $event.stopPropagation();
                Restangular.one("Persons/DeletePersonPositionOrder/" + position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.moveOrderToPosition = function ($event, person_position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MoveOrderToPosition/" + person_position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            $scope.moveOrderToPersonPosition = function ($event, person_position_id) {
                $event.stopPropagation();
                Restangular.one("Persons/MoveOrderToPersonPosition/" + person_position_id).get().then(function () {
                    $scope.loadGroups();
                    $scope.loadPerson(true);
                });
            };

            // C

            $scope.copyMailToClipboard = function ($event, email) {
                $event.stopPropagation();
                clipboard.copyText(email);
            };

            // Gestión de privados

            $scope.noneAllowedDialogCheck = function () {

                if ($scope.person.is_private == true) {

                    if ((!$scope.allowedGroups || $scope.allowedGroups.length <= 0) && (!$scope.allowedUsers || $scope.allowedUsers.length <= 0)) {
                        $scope.person.is_private = false;
                        modalService.message({
                            title: $filter('translate')('persons.none_allowed_title'),
                            message: $filter('translate')('persons.none_allowed_message'),
                            onAccept: function () { }
                        });
                    }
                }

            };

            $scope.setDefaultAllowedUser = function () {
                $scope.changesNotSaved = true;
                let userId = LoginService.get("userId");
                if (!$scope.allowedUsers.map(u => u.entityId).includes(userId))
                Restangular.all("Persons").customGET("AddAllowedEntity", { id: $scope.person.id, entityId: userId, entityType: "user" }).then(function () {
                    GetAllowedUsers();
                })
            };

            $scope.sendMailing = function (personId) {

                var listIds = [];
                listIds.push(personId);

                var listEmailsIds = [];
                Restangular.all("Persons").customGET("GetAllPersonsEmailsIds", { persons_ids: listIds }).then(function (res) {
                    listEmailsIds = res;
                    var params = {
                        entity_type: "persons",
                        entity_type_id: 0,
                        persons_ids: listIds,
                        mail_account_id: null,
                        mail_account_reply: null,
                        app_enabled: $scope.app_enabled,
                        documents: { for_event_guest: false }
                    };
                    notificationService.notificationMail({
                        params: params,
                        onAccept: function (data) {
                            toastr.success($filter('translate')('notifications.sending_mail_success'));
                        }
                    });
                });
            };

            $scope.loadTags = function () {
                if ($stateParams.id != null) {
                    Restangular.all("Tags").customGET("TagsByEntityTypeAndId", { entity_type: "persons", entity_id: $scope.person.id }).then(function (result) {
                        $scope.tags = result;
                    });

                }
            }

            $scope.createNewTag = function () {

                let $modalInstance = $uibModal.open({

                    animation: true,
                    template: TagsModalView,
                    size: "ld",
                    controller: "tagsModalCtrl",
                    scope: $scope,
                    resolve: {

                        is_search: function () {
                            return false
                        },

                        selected_tags_ids: function () {
                            return [];
                        },
                        entity_type: function () {
                            return "persons"
                        },
                        entity_id: function () {
                            return null;
                        }

                    }

                });

            }

            $scope.assignTags = function () {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AssignTagsPersonModalView,
                    size: "ld",
                    controller: "tagsModalCtrl",
                    scope: $scope,
                    resolve: {


                        is_search: function () {
                            return false
                        },

                        selected_tags_ids: function () {
                            return [];
                        },

                        entity_type: function () {
                            return "persons";
                        },
                        entity_id: function () {
                            return $stateParams.id;
                        }
                    }
                });

                $modalInstance.result.then(function (data) {
                    $timeout(function () {
                        $scope.loadTags();
                    }, 800);
                }, function () {
                });

            }

            $scope.removeTag = function (tag_id) {

                Restangular.all('Tags').customPOST({}, "DeleteTagsEntity", { entity_id: tag_id }).then(function (result) {
                    $scope.loadTags();
                })

            };

        }
    ])

    //controlador añadir grupo
    .controller("AddNewGroupModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'group_id', function (LoginService, $scope, $uibModalInstance, Restangular, group_id) {
        $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");
        $scope.group_id = group_id;
        // logService.debug(group_id);
        $scope.callbackClose = function (mode, result) {
            // logService.debug("Linea 1009");
            $uibModalInstance.close(result);
        };

        $scope.getGroupId = function () {
            // logService.debug("getGroupId", $scope.group_id);
            return $scope.group_id;
        };

        $scope.onCancel = function () {
            //$uibModalInstance.dismiss('cancel');
            Restangular.all('Groups').get($scope.group_id).then(function (result) {
                $uibModalInstance.close(result);
            });
        };

    }])

    .controller("PersonPositionAddressModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'personPositionAddress', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, personPositionAddress) {

        $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");
        $scope.personPositionAddressModal = (!angular.isUndefined(personPositionAddress) ? angular.copy(personPositionAddress) : {});
        $scope.personPositionAddressOrigin = (!angular.isUndefined(personPositionAddress) ? personPositionAddress : {});
        console.log($scope.defaultCountry);
        Restangular.all('Countries').getList().then(function (countries) {

            $scope.countries = countries;
            //Seleccionamos el correspondiente.
            if ($scope.personPositionAddressModal != null) {
                $scope.personPositionAddressModal.FK_persons_positions_addresses_countries = {};
                $scope.countries.forEach(function (pct) {
                    if (pct.id == $scope.personPositionAddressModal.country_id) $scope.personPositionAddressModal.FK_persons_positions_addresses_countries.selected = pct;
                });
            }
        });

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.savePersonPositionAddress = function () {
            //Devolvemos el control al principal
            $uibModalInstance.close({ edited: $scope.personPositionAddressModal, origin: $scope.personPositionAddressOrigin });
        };//savePositionAddress

    }])

    .controller("PersonPositionContactModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'personPositionContactInfo', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, personPositionContactInfo) {

        $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");
        $scope.personPositionContactModal = (!angular.isUndefined(personPositionContactInfo) ? angular.copy(personPositionContactInfo) : {});
        $scope.personPositionContactOrigin = (!angular.isUndefined(personPositionContactInfo) ? personPositionContactInfo : {});

        Restangular.all('PersonsPositionsContactsTypes').getList().then(function (personsPositionsContactsTypes) {
            // logService.debug(personsPositionsContactsTypes);
            $scope.personsPositionsContactsTypes = personsPositionsContactsTypes;
            //Seleccionamos el correspondiente.
            if ($scope.personPositionContactModal != null) {
                $scope.personsPositionsContactsTypes.forEach(function (pct) {
                    if (pct.id == $scope.personPositionContactModal.person_position_contact_type_id) $scope.personPositionContactModal.FK_persons_positions_contacts_positions_contacts_types.selected = pct;
                });
            }
        });

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.savePersonPositionContact = function () {
            //Devolvemos el control al principal

            $uibModalInstance.close({ edited: $scope.personPositionContactModal, origin: $scope.personPositionContactOrigin });

        };//save


    }])

    .controller("AllowedUsersModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'person_id', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, person_id) {

        $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");
        $scope.userToAdd = {};
        $scope.groupToAdd = {};




        // Recogemos los datos

        Restangular.all('Users').getList().then(function (results) {
            $scope.allowedUsersSelect = results;

        });

        Restangular.all('UsersGroups').getList().then(function (results) {
            $scope.allowedGroupsSelect = results;

        });

        // Añadimos 
        $scope.addAllowedUser = function () {
            if (!$scope.allowedUsers.includes($scope.userToAdd.selected))
            Restangular.all("Persons").customGET("AddAllowedEntity", { id: person_id, entityId: $scope.userToAdd.selected.id, entityType: "user" }).then(function () {
                $scope.allowedUsers.push($scope.userToAdd.selected);
                $scope.userToAdd.selected = null;
                toastr.success($filter('translate')('persons.allowed_success'));
            })
        };

        $scope.addAllowedGroup = function () {
            if (!$scope.allowedGroups.includes($scope.groupToAdd.selected))
            Restangular.all("Persons").customGET("AddAllowedEntity", { id: person_id, entityId: $scope.groupToAdd.selected.id, entityType: "group" }).then(function () {
                $scope.allowedGroups.push($scope.groupToAdd.selected);
                $scope.groupToAdd.selected = null;
                toastr.success($filter('translate')('persons.allowed_group_success'));

            })
        };

        //Eliminamos 
        $scope.removeAllowedUser = function (user) {
            Restangular.all("Persons").customGET("DeleteAllowedEntity", { id: person_id, entityId: user.id, entityType: "user"}).then(function () {
                let index = $scope.allowedUsers.indexOf(user);
                $scope.allowedUsers.splice(index, 1);
                toastr.success($filter('translate')('persons.deleted_allowed_success'));


            })
        };

        $scope.removeAllowedGroup = function (group) {
            Restangular.all("Persons").customGET("DeleteAllowedEntity", { id: person_id, entityId: group.id, entityType: "group"} ).then(function () {
                let index = $scope.allowedGroups.indexOf(group)
                $scope.allowedGroups.splice(index, 1);
                toastr.success($filter('translate')('persons.deleted_allowed_group_succes'));
            })
        };

        // Control del modal
        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

;
